export const pluginPrefix = 'PLUGIN:CUSTOMER_DISPLAY:';

export const SET_HAS_PERMISSION = `${pluginPrefix} SET_HAS_PERMISSION`;
export const SET_FETCHED_INITIAL_SCREEN_DETAILS = `${pluginPrefix} SET_FETCHED_INITIAL_SCREEN_DETAILS`;
export const SET_SCREENS = `${pluginPrefix} SET_SCREENS`;
export const SET_SELECTED_SCREEN = `${pluginPrefix} SET_SELECTED_SCREEN`;
export const SET_NEEDS_START_NEW = `${pluginPrefix} SET_NEEDS_START_NEW`;
export const SET_PROCESSING_CUSTOMER = `${pluginPrefix} SET_PROCESSING_CUSTOMER`;
export const SET_NEED_TO_CLOSE_CUSTOMER_FORM_ON_DISPLAY = `${pluginPrefix} SET_NEED_TO_CLOSE_CUSTOMER_FORM_ON_DISPLAY`;
export const RESET_CUSTOMER_FORM_STATE = `${pluginPrefix} RESET_CUSTOMER_FORM_STATE`;
